<template>
    <div>
        <div class="page-header pr-0">
            <h2><a href="#"><i class="fas fa-utensils"></i></a></h2>
            <ol class="breadcrumbs">
                <li class="active"><span>Restaurant v2</span></li>
                <li><span class="text-muted">Configuración operativa</span></li>
            </ol>
        </div>

        <div class="card mb-0">
            <div class="card-body">
                <el-tabs v-model="activeName" type="border-card" class="rounded">
                    <el-tab-pane label="Salones" name="rooms">
                        <div class="row">
                            <div class="col-md-4">
                                <label>Nombre</label>
                                <el-input v-model="roomForm.name"></el-input>
                            </div>
                            <div class="col-md-3 mt-4">
                                <el-switch v-model="roomForm.active" active-text="Activo"
                                    inactive-text="Inactivo"></el-switch>
                            </div>
                            <div class="col-md-3 mt-4">
                                <el-button type="primary" @click="saveRoom">Guardar</el-button>
                                <el-button @click="resetRoom">Nuevo</el-button>
                            </div>
                        </div>

                        <div class="table-responsive mt-3">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Salón</th>
                                        <th>Estado</th>
                                        <th class="text-right">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(row, index) in rooms" :key="row.id">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ row.name }}</td>
                                        <td>
                                            <el-tag :type="row.active ? 'success' : 'info'">
                                                {{ row.active ? 'Activo' : 'Inactivo' }}
                                            </el-tag>
                                        </td>
                                        <td class="text-right">
                                            <button class="btn btn-xs btn-info" @click="editRoom(row)">Editar</button>
                                            <button class="btn btn-xs btn-danger"
                                                @click="deleteRoom(row.id)">Eliminar</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </el-tab-pane>

                    <el-tab-pane label="Áreas de producción" name="areas">
                        <div class="row">
                            <div class="col-md-4">
                                <label>Nombre</label>
                                <el-input v-model="areaForm.name"></el-input>
                            </div>
                            <div class="col-md-3">
                                <label>Código</label>
                                <el-input v-model="areaForm.code"></el-input>
                            </div>
                            <div class="col-md-2 mt-4">
                                <el-switch v-model="areaForm.active" active-text="Activo"
                                    inactive-text="Inactivo"></el-switch>
                            </div>
                            <div class="col-md-3 mt-4">
                                <el-button type="primary" @click="saveArea">Guardar</el-button>
                                <el-button @click="resetArea">Nuevo</el-button>
                            </div>
                        </div>

                        <div class="table-responsive mt-3">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Área</th>
                                        <th>Código</th>
                                        <th>Estado</th>
                                        <th class="text-right">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(row, index) in areas" :key="row.id">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ row.name }}</td>
                                        <td>{{ row.code }}</td>
                                        <td>
                                            <el-tag :type="row.active ? 'success' : 'info'">
                                                {{ row.active ? 'Activo' : 'Inactivo' }}
                                            </el-tag>
                                        </td>
                                        <td class="text-right">
                                            <button class="btn btn-xs btn-info" @click="editArea(row)">Editar</button>
                                            <button class="btn btn-xs btn-danger"
                                                @click="deleteArea(row.id)">Eliminar</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </el-tab-pane>

                    <el-tab-pane label="Mesas" name="tables">
                        <div class="row">
                            <div class="col-md-4">
                                <label>Salón</label>
                                <el-select v-model="tableForm.restaurant_room_id" filterable>
                                    <el-option v-for="option in tableOptions.rooms" :key="option.id"
                                        :label="option.name" :value="option.id"></el-option>
                                </el-select>
                            </div>
                            <div class="col-md-3">
                                <label>Mesa</label>
                                <el-input v-model="tableForm.name"></el-input>
                            </div>
                            <div class="col-md-2">
                                <label>Capacidad</label>
                                <el-input-number v-model="tableForm.capacity" :min="1"></el-input-number>
                            </div>
                            <div class="col-md-3 mt-4">
                                <el-switch v-model="tableForm.active" active-text="Activo"
                                    inactive-text="Inactivo"></el-switch>
                            </div>
                            <div class="col-md-12 mt-3">
                                <el-button type="primary" @click="saveTable">Guardar</el-button>
                                <el-button @click="resetTable">Nuevo</el-button>
                            </div>
                        </div>

                        <div class="table-responsive mt-3">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Salón</th>
                                        <th>Mesa</th>
                                        <th>Capacidad</th>
                                        <th>Estado</th>
                                        <th class="text-right">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(row, index) in diningTables" :key="row.id">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ row.room ? row.room.name : '' }}</td>
                                        <td>{{ row.name }}</td>
                                        <td>{{ row.capacity }}</td>
                                        <td>
                                            <el-tag :type="row.active ? 'success' : 'info'">
                                                {{ row.active ? 'Activo' : 'Inactivo' }}
                                            </el-tag>
                                        </td>
                                        <td class="text-right">
                                            <button class="btn btn-xs btn-info" @click="editTable(row)">Editar</button>
                                            <button class="btn btn-xs btn-danger"
                                                @click="deleteTable(row.id)">Eliminar</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </el-tab-pane>

                    <el-tab-pane label="Productos por área" name="items">
                        <div class="row">
                            <div class="col-md-5">
                                <label>Producto</label>
                                <el-select v-model="itemSettingForm.item_id" filterable>
                                    <el-option v-for="option in itemSettingOptions.items" :key="option.id"
                                        :label="`${option.internal_id || ''} - ${option.description}`"
                                        :value="option.id"></el-option>
                                </el-select>
                            </div>
                            <div class="col-md-4">
                                <label>Área de producción</label>
                                <el-select v-model="itemSettingForm.restaurant_production_area_id" filterable clearable>
                                    <el-option v-for="option in itemSettingOptions.production_areas" :key="option.id"
                                        :label="option.name" :value="option.id"></el-option>
                                </el-select>
                            </div>
                            <div class="col-md-3 mt-4">
                                <el-switch v-model="itemSettingForm.print_on_kitchen" active-text="Imprime"
                                    inactive-text="No imprime"></el-switch>
                            </div>
                            <div class="col-md-12 mt-3">
                                <el-button type="primary" @click="saveItemSetting">Guardar</el-button>
                                <el-button @click="resetItemSetting">Nuevo</el-button>
                            </div>
                        </div>

                        <div class="table-responsive mt-3">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Producto</th>
                                        <th>Área</th>
                                        <th>Comanda</th>
                                        <th>Estado</th>
                                        <th class="text-right">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(row, index) in itemSettings" :key="row.id">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ row.item ? row.item.description : '' }}</td>
                                        <td>{{ row.production_area ? row.production_area.name : '' }}</td>
                                        <td>{{ row.print_on_kitchen ? 'Sí' : 'No' }}</td>
                                        <td>
                                            <el-tag :type="row.active ? 'success' : 'info'">
                                                {{ row.active ? 'Activo' : 'Inactivo' }}
                                            </el-tag>
                                        </td>
                                        <td class="text-right">
                                            <button class="btn btn-xs btn-info"
                                                @click="editItemSetting(row)">Editar</button>
                                            <button class="btn btn-xs btn-danger"
                                                @click="deleteItemSetting(row.id)">Eliminar</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>

<script>
import { deletable } from '@mixins/deletable'

export default {
    mixins: [deletable],
    data() {
        return {
            activeName: 'rooms',
            rooms: [],
            areas: [],
            roomForm: {},
            areaForm: {},
            diningTables: [],
            itemSettings: [],
            tableOptions: {
                rooms: [],
                statuses: [],
            },
            itemSettingOptions: {
                items: [],
                production_areas: [],
            },
            tableForm: {},
            itemSettingForm: {},
        }
    },
    created() {
        this.resetRoom()
        this.resetArea()
        this.getRooms()
        this.getAreas()
        this.resetTable()
        this.resetItemSetting()
        this.getTableOptions()
        this.getDiningTables()
        this.getItemSettingOptions()
        this.getItemSettings()
    },
    methods: {
        resetRoom() {
            this.roomForm = { id: null, name: null, active: true }
        },
        resetArea() {
            this.areaForm = { id: null, name: null, code: null, active: true }
        },
        getRooms() {
            this.$http.get('/restaurant/v2/rooms/records').then(response => {
                this.rooms = response.data.data
            })
        },
        getAreas() {
            this.$http.get('/restaurant/v2/production-areas/records').then(response => {
                this.areas = response.data.data
            })
        },
        saveRoom() {
            this.$http.post('/restaurant/v2/rooms', this.roomForm).then(response => {
                this.$message.success(response.data.message)
                this.resetRoom()
                this.getRooms()
            })
        },
        saveArea() {
            this.$http.post('/restaurant/v2/production-areas', this.areaForm).then(response => {
                this.$message.success(response.data.message)
                this.resetArea()
                this.getAreas()
            })
        },
        editRoom(row) {
            this.roomForm = Object.assign({}, row)
        },
        editArea(row) {
            this.areaForm = Object.assign({}, row)
        },
        deleteRoom(id) {
            this.destroy(`/restaurant/v2/rooms/${id}`).then(() => this.getRooms())
        },
        deleteArea(id) {
            this.destroy(`/restaurant/v2/production-areas/${id}`).then(() => this.getAreas())
        },
        resetTable() {
            this.tableForm = {
                id: null,
                restaurant_room_id: null,
                name: null,
                capacity: 1,
                status: 'available',
                active: true,
            }
        },
        resetItemSetting() {
            this.itemSettingForm = {
                item_id: null,
                restaurant_production_area_id: null,
                print_on_kitchen: true,
                active: true,
            }
        },
        getTableOptions() {
            this.$http.get('/restaurant/v2/dining-tables/tables').then(response => {
                this.tableOptions = response.data
            })
        },
        getDiningTables() {
            this.$http.get('/restaurant/v2/dining-tables/records').then(response => {
                this.diningTables = response.data.data
            })
        },
        getItemSettingOptions() {
            this.$http.get('/restaurant/v2/item-settings/tables').then(response => {
                this.itemSettingOptions = response.data
            })
        },
        getItemSettings() {
            this.$http.get('/restaurant/v2/item-settings/records').then(response => {
                this.itemSettings = response.data.data
            })
        },
        saveTable() {
            this.$http.post('/restaurant/v2/dining-tables', this.tableForm).then(response => {
                this.$message.success(response.data.message)
                this.resetTable()
                this.getDiningTables()
            })
        },
        saveItemSetting() {
            this.$http.post('/restaurant/v2/item-settings', this.itemSettingForm).then(response => {
                this.$message.success(response.data.message)
                this.resetItemSetting()
                this.getItemSettings()
            })
        },
        editTable(row) {
            this.tableForm = Object.assign({}, row)
        },
        editItemSetting(row) {
            this.itemSettingForm = {
                item_id: row.item_id,
                restaurant_production_area_id: row.restaurant_production_area_id,
                print_on_kitchen: !!row.print_on_kitchen,
                active: !!row.active,
            }
        },
        deleteTable(id) {
            this.destroy(`/restaurant/v2/dining-tables/${id}`).then(() => this.getDiningTables())
        },
        deleteItemSetting(id) {
            this.destroy(`/restaurant/v2/item-settings/${id}`).then(() => this.getItemSettings())
        },
    }
}
</script>


// WEBPACK FOOTER //
// modules/Restaurant/Resources/assets/js/views/v2/configuration.vue